import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderProgressWebinars extends ResourceItemHtmlProvider {
    constructor(filterServices) {
        super(filterServices);
        this.cssClasses = {
            col: 'col-8 -xl-half -s-full -mb4',
            resourceBox: 'Elevated -full -pr -bg-white -br2',
            resourceWrapper: 'ResourceItem',
            resourceImage: 'ResourceItem-image Section-bg',
            resourceLabel: 'ResourceLabel -mb0 -pa -l0 -b0 -z1',
            resourceContent: 'ResourceItem-info -ps',
            resourceData: 'ResourceItem-hint -cf',
            resourceTitle: 'ResourceItem-title h4 -mb0 -ps HoverBox HoverBox--over -accento-0',
            resourceDescription: 'ResourceItem-summary'
        }

        this.minLabel = { en: 'min', de: 'minuten', nl: 'minuten', es: 'minutos', pt: 'minutos', fr: 'minutes', sv: 'minuter', ja: '分', 'zh-TW': '分' };
        this.onDemandLabel = { en: 'On-Demand', de: 'On-Demand', nl: 'On-Demand', es: 'A la carta', pt: 'Sob demanda', fr: 'À la demande', ja: 'オンデマンド', 'zh-TW': '隨選' };
        this.upcomingLabel = { en: 'Upcoming', de: 'Kommende', nl: 'Upcoming', es: 'Próximos', pt: 'Próximos', fr: 'À venir', ja: 'ライブ予定', 'zh-TW': '即將到來' };
    }

    getItemHtml(item, relatedMedia) {
        let { col, resourceBox, resourceWrapper, resourceImage, resourceLabel, resourceContent, resourceData, resourceTitle, resourceDescription} = this.cssClasses;
        let { imageData } = super.setRelatedMedia(item, relatedMedia);
        let webinarLabel = '';
        let summary = '';
        let startDate = '';
        let startTime = '';
        let resourceUrl = '';
        const { Title, UrlName: resourcePath } = item;

        if (item.CTAUrl) {
            resourceUrl = item.CTAUrl;
        }
        else {
            const pageUrl = super.getResourceUrl(item.contenttypes[0]);
            resourceUrl = `${pageUrl}/${resourcePath}`;
        }

        const selectedLanguage = this.filterService.getSelectedLanguage();

        if(item.IsUpcomming) {
            webinarLabel = this.upcomingLabel[selectedLanguage];
            resourceLabel += ' ResourceLabel--upcoming';

            var localDate = new Date(item.StartDate);
            startDate = localDate.toLocaleDateString('en-us', { year: 'numeric', month: 'long', day: 'numeric' });
            if(localDate.getMinutes() > 0){
                startTime = localDate.toLocaleTimeString('en-us', { timeStyle: 'short', hour12: true });
             }
             else{
                 startTime = localDate.toLocaleTimeString('en-us', { hour: 'numeric', hour12: true });
             }
 
             startTime = startTime.replace('AM', 'a.m.').replace('PM', 'p.m.') + ' ';
            
            var enTimezoneString = new Date().toLocaleString("en-US", { hour: "numeric", minute: "numeric", second: "numeric", timeZoneName: "long" });
            const timeZone = enTimezoneString?.split(/(AM|PM)/)[2]?.trim();
            const timeZoneParts = timeZone?.split(' ');
            if (timeZoneParts && timeZoneParts.length > 0) {
                for (const part of timeZoneParts) {
                    startTime += part[0]
                }
            } else {
                const timeZoneTranslatedName = /\((.*)\)/.exec(new Date().toString())[1];
                timeZoneParts = timeZoneTranslatedName?.split(' ');
                for (const part of timeZoneParts) {
                    startTime += part[0]
                }
            }
        }
        else {
            webinarLabel = this.onDemandLabel[selectedLanguage];
            resourceLabel += ' ResourceLabel--onDemand';
        }

        summary = item.Summary;
        if (summary) {
            resourceWrapper += ' ResourceItem--overlay';
            resourceContent += ' ResourceItem-info--cut';
        }

        if (!imageData || !imageData.Url) {
            imageData = {
                Url: 'https://d117h1jjiq768j.cloudfront.net/images/default-source/resource-center/webinar/webinar-3-thumbnail.svg?v=2',
                AlternativeText: 'default webinar thumbnail'
            };
        }

        const html = `
        <div class="${col}">
            <div class="${resourceBox}">
                <div class="${resourceWrapper}">
                    <div class="${resourceImage}">
                        <img src="${imageData.Url}" alt="${imageData.AlternativeText}">
                        <p class="${resourceLabel}">${webinarLabel}</p>
            </div>
                    <div class="${resourceContent}">
                        <div class="${resourceData}">
                            ${startDate || startTime ? `<span class="-fl">${startDate}</span><span class="-fr">${startTime}</span>` : '&nbsp;'}
            </div>
                        <a href="${resourceUrl}" class="${resourceTitle}">${this.encodeHtml(Title)}</a>
                        ${summary ?  `<div class="${resourceDescription}">${summary}</div>` : ''}
                    </div>
                </div>
            </div>
        </div>
        `;

        return html;
    }

    getDate(utcDate){
        let date = new Date(utcDate);
        const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
        return date.toLocaleDateString(undefined, options);
    }
}
